export function Company() {
    return (
        <h2>Company</h2>
    )
}